<template>
  <div class="fast-mission-intro">
      <xi-top></xi-top>
      <div class="banner-out-wrapper">
          <div class="banner">
              <div class="large-slogan">
                  推荐任务等你来抢
              </div>
              <div class="sub-slogan">
                  有声化平台自动推荐功能上线
              </div>
          </div>
      </div>
      <div class="content-out-wrapper">
          <div class="content-inner-wrapper">
              <div class="row-wrapper">
                  <img :src="$store.state.IMG_HOST+'fastMissionIntro/1.png'">
                  <div class="content-wrapper">
                      <span class="content-title">除了参加海选，这样也能获得有声化任务</span>
                      <span class="content">有声化平台任务发布系统进入2.0时代。不仅是您主动参与海选，我们也自动将为您推荐适合您的演播任务。您只需要选择您最擅长演播的书籍类型，按照要求上传试音，当有该类型合适的演播任务时，系统将自动向你发送录制邀约。获得演播机会，就是那么简单。</span>
                  </div>
              </div>
              <div class="row-wrapper">
                  <div class="content-wrapper">
                      <span class="content-title">化繁为简，一次试音就够了</span>
                      <span class="content">在主播工作台-声音标签中按照要求上传您的试音文件。审核通过后，系统将持续为您寻找适合您演播的任务。告别繁琐试音，只要一次就够了。</span>
                      <router-link class="content-button" :to="{name: 'anchorMyVoiceTag'}">立刻录制上传您的声音标签</router-link>
                  </div>
                  <img :src="$store.state.IMG_HOST+'fastMissionIntro/2.png'">
              </div>
              <div class="row-wrapper">
                  <img :src="$store.state.IMG_HOST+'fastMissionIntro/3.png'">
                  <div class="content-wrapper">
                      <span class="content-title">系统推荐，快速抢单手慢无</span>
                      <span class="content">当有合适的演播任务时，系统将通过手机短信和站内信的方式同时向数个主播发起邀约，最先登录主播工作台并抢到邀约的主播将获得播讲权。录制演播机会，手快有，手慢无。</span>
                  </div>
              </div>
          </div>
      </div>
      <div class="steps-out-wrapper">
          <div class="steps-inner-wrapper">
              <div class="steps-slogan-wrapper">
                  <span class="slogan">简单三步</span>
                  <span class="slogan">轻松获得有声化任务</span>
              </div>
              <div class="steps-wrapper">
                  <div class="step">
                      <img class="step-img" :src="$store.state.IMG_HOST+'fastMissionIntro/upload.png'">
                      <span class="step-content">1.登录主播工作台<br>上传声音标签</span>
                  </div>
                  <div class="step">
                      <img class="step-img" :src="$store.state.IMG_HOST+'fastMissionIntro/invitation.png'">
                      <span class="step-content">2.系统自动匹配<br>演播任务</span>
                  </div>
                  <div class="step">
                      <img class="step-img" :src="$store.state.IMG_HOST+'fastMissionIntro/match.png'">
                      <span class="step-content">3.收到任务邀约<br>快速抢单</span>
                  </div>
              </div>
          </div>
      </div>
      <xi-footer></xi-footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import XiFooter from '../components/Footer.vue';
  import XiTop from '../components/Top.vue';
  export default {
    components: {
      axios,
      XiFooter,
      XiTop
    },
    data() {
      return {
            
      }
    },
    methods: {
    
    },
    computed: {
        
    },
    beforeMount() {
          
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/specialTopic/fast-mission-intro.scss";
    @import "../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// FastMissionIntro.vue?63ee42ad